<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field name="dealerId" label="Dealer ID" id="dealerId" v-model="dealerId" clearable></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          name="customNumber"
          label="CustomerNumber"
          id="custNo"
          v-model="custNo"
          clearable
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field name="CSN" label="CSN" id="csn" v-model="csn" clearable></v-text-field>
      </v-col>
      <v-col>
        <v-text-field name="RunID" label="Run ID" id="runId" v-model="runId" clearable></v-text-field>
      </v-col>
      <v-col>
        <v-btn rounded color="primary" @click="search">Search</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ag-grid-vue
          style="width: 100%; height: 500px;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @filterModified="onFilterModified"
          @filterChanged="onFilterChanged"
          enableCellTextSelection
        ></ag-grid-vue>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { mapActions } from "vuex";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "previousPayments",
  data() {
    return {
      columnDefs: null,
      rowData: null,
      body: {},
      custNo: null,
      csn: null,
      runId: null,
      dealerId: null,
    };
  },
  components: {
    AgGridVue,
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    search() {
      let vm = this;
      Object.assign(this.body, {
        customerNo: vm.custNo || null,
        csn: vm.csn || null,
        runId: vm.runId || 0,
        dealerId: vm.dealerId || null,
        numResults: 25,
      });

      this.getRowData(this.body);
    },
    onFilterChanged(e) {
      console.log("onFilterChanged", e);
      console.log("gridApi.getFilterModel() =>", e.api.getFilterModel());
    },
    onFilterModified(e) {
      console.log("onFilterModified", e);
      console.log("filterInstance.getModel() =>", e.filterInstance.getModel());
      console.log(
        "filterInstance.getModelFromUi() =>",
        e.filterInstance.getModelFromUi()
      );
    },
    getRowData(val) {
      let vm = this;
      let query = {
        message: "Previous Payments loaded",
        url: `Commissions/PreviousPayments`,
        method: "post",
        body: val,
      };
      this.CommissionsRequest(query)
        .then((data) => {
          vm.rowData = data;
        })
        .catch(() => {});
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Dealer",
        field: "dealerId",
        filter: "agNumberColumnFilter",
        filterParams: { applyButton: true, resetButton: true },
        sortable: true,
      },
      {
        headerName: "CustNo",
        field: "custNo",
        filter: "agNumberColumnFilter",
        filterParams: { applyButton: true, resetButton: true },
        sortable: true,
      },

      {
        headerName: "CSN",
        field: "csn",
        filter: "agTextColumnFilter",
        filterParams: { applyButton: true, resetButton: true },
        sortable: true,
      },
      {
        headerName: "Rate Plan",
        field: "comment",
        filter: "agNumberColumnFilter",
        filterParams: { applyButton: true, resetButton: true },
        sortable: true,
      },
      {
        headerName: "Date Paid",
        field: "datePaid",
        filter: true,
        sortable: true,
        valueFormatter: this.dateFormatter,
      },
      { headerName: "RunID", field: "runId", filter: true, sortable: true },
      {
        headerName: "Amount",
        field: "amount",
        filter: "agNumberColumnFilter",
        filterParams: { applyButton: true, resetButton: true },
        valueFormatter: this.currencyFormatter,
        sortable: true,
      },
    ];

    this.search();
  },
};
</script>

<style lang="scss" scoped>
// @import "node_modules/ag-grid-community/dist/styles/ag-grid.css";
// @import "node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
</style>
